import { assessmentLaunchDescriptorSchema as e } from "./assessment-launch.js";
import { z as t } from "zod";
//#region src/proxy-message/contracts.ts
var n = {
	ping: {
		requestSchema: t.undefined(),
		responseSchema: t.literal("pong")
	},
	getExtensionVersion: {
		requestSchema: t.undefined(),
		responseSchema: t.string()
	},
	isIncognitoAllowed: {
		requestSchema: t.undefined(),
		responseSchema: t.boolean()
	},
	isInManagedGuestSession: {
		requestSchema: t.undefined(),
		responseSchema: t.boolean()
	},
	compatibilityCheckInProgress: {
		requestSchema: t.undefined(),
		responseSchema: t.boolean()
	},
	injectCompatibilityCheckIframe: {
		requestSchema: t.undefined(),
		responseSchema: t.any()
	},
	getExtensionUpstream: {
		requestSchema: t.undefined(),
		responseSchema: t.string()
	},
	setExtensionUpstream: {
		requestSchema: t.object({ origin: t.string() }),
		responseSchema: t.object({ success: t.boolean() })
	},
	checkVerityThemeExists: {
		requestSchema: t.undefined(),
		responseSchema: t.boolean()
	},
	loginUsingAuthCode: {
		requestSchema: t.object({
			accountId: t.string(),
			authCode: t.string()
		}),
		responseSchema: t.void()
	},
	setAccountId: {
		requestSchema: t.object({ accountId: t.string() }),
		responseSchema: t.void()
	},
	setRefreshToken: {
		requestSchema: t.object({ refreshToken: t.string() }),
		responseSchema: t.void()
	},
	changeLanguage: {
		requestSchema: t.object({ language: t.string() }),
		responseSchema: t.void()
	},
	startCompatibilityCheck: {
		requestSchema: t.object({ quizInfo: t.any().optional() }),
		responseSchema: t.object({ success: t.boolean() })
	},
	canvasQuizMenuLtiQuizInfo: {
		requestSchema: t.undefined(),
		responseSchema: t.object({
			hostname: t.string(),
			courseId: t.string(),
			quizId: t.string()
		}).optional()
	},
	startThirdPartyAssessmentScript: {
		requestSchema: t.object({
			assessmentUrl: t.any().optional(),
			quizInfo: t.any().optional(),
			thirdPartyPlatformId: t.any().optional(),
			inlineSetup: t.boolean().optional()
		}),
		responseSchema: t.object({
			success: t.boolean(),
			reason: t.string().optional(),
			inlineSetup: t.boolean().optional()
		})
	},
	startSetupGuideWorkflow: {
		requestSchema: t.object({
			type: t.enum([
				"Create Assessment",
				"Take Assessment",
				"View Results"
			]),
			profileId: t.number().optional(),
			createQuizUrl: t.string().optional(),
			takeQuizUrl: t.string().optional(),
			resultQuizUrl: t.string().optional(),
			setupLmsQuizId: t.string().optional(),
			setupLmsCourseId: t.string().optional(),
			lms: t.enum([
				"canvas",
				"moodle",
				"BlackboardLearn",
				"desire2learn"
			]),
			isFastTrack: t.boolean().optional(),
			isBlackboardUltra: t.boolean().optional(),
			initialCreateStepComplete: t.boolean().optional()
		}),
		responseSchema: t.object({ success: t.boolean() })
	},
	stopSetupGuideWorkflow: {
		requestSchema: t.undefined(),
		responseSchema: t.object({ success: t.boolean() })
	},
	endDemoProctoring: {
		requestSchema: t.object({
			proctoringSessionId: t.uuid(),
			assessment: e
		}).strict(),
		responseSchema: t.object({ success: t.literal(!0) }).strict()
	},
	openExtensionSettingsPage: {
		requestSchema: t.undefined(),
		responseSchema: t.void()
	}
}, r = t.enum(Object.keys(n));
//#endregion
export { r as ProxyHandlerNameSchema, n as proxyMessageContracts };
